import { Button, ButtonProps, CircularProgress } from '@mui/material';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

interface IWizardButtonProp extends ButtonProps {
  isLoading?: Boolean;
}

const StyledButton = styled(Button)`
  background-color: ${props => (props.disabled ? 'gray' : 'rgb(32, 144, 136)')} !important;
  border-radius: 15px !important;
  min-width: 180px !important;
  color: white !important;
  position: relative;
`;

const StyledCircularProgress = styled(CircularProgress)`
  color: white !important;
  position: absolute;
  top: 10px;
  left: 15px;
`;

const WizardButton = forwardRef<any, IWizardButtonProp>((props: IWizardButtonProp, ref) => {
  const { isLoading, ...rest } = props;

  return (
    <StyledButton {...rest} variant="contained" size="large" ref={ref}>
      {isLoading && <StyledCircularProgress size={20} />}
      {props.children}
    </StyledButton>
  );
});

export default WizardButton;
